import React, { Component } from 'react';
import { View, Text, TextInput, Button, StyleSheet, Picker, ActivityIndicator } from 'react-native';
import { Redirect } from 'react-router-dom';
import AuthContainer from '../../components/AuthContainer';
import firebase, { storageRef, db } from '../../configs/firebase';

const URLExpression = new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi);

const categories = [
    { name: "Funny", id: 1 },
    { name: "Space", id: 2 },
    { name: "Celebrities", id: 3 },
    { name: "Animals", id: 4 },
    { name: "Science", id: 5 },
    { name: "Lifestyle", id: 6 },
    { name: "Biology", id: 7 },
    { name: "Health", id: 8 },
    { name: "World", id: 9 },
    { name: "Sports", id: 10 },
    { name: "History", id: 11 },
    { name: "Society", id: 12 },
];

const IMAGE_FOLDER_NAME = 'posters';
const POSTER_COLLECTION_FOLDER_NAME = 'fpAppContent';

const initialState = {
    posterTitle: null,
    posterExternalUrl: '',
    posterDescription: null,
    posterContentType: null,
    posterCategoryId: null,
    selectedFile: null,
    selectedFileName: null,
    uploadedFileUrl: null,
    uploadProgress: 0,
    loader: false,
    submitted: false,
    goHome: false,
}

export default class NewPoster extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;

        this.handleselectedFile = this.handleselectedFile.bind(this);
        this._startUploadingFile = this._startUploadingFile.bind(this);
        this.deleteUploaded = this.deleteUploaded.bind(this);
    }


    handleselectedFile = event => {

        if (event.target.files[0].type === 'image/jpeg') {
            this.setState({
                selectedFile: event.target.files[0],
                selectedFileName: event.target.files[0].name,
                //loader: true,
            }, () => {
                //this._startUploadingFile();

            })
        } else {
            alert('Only .jpg or .jpeg files allowed');
        }

    }

    _startUploadingFile() {
        // Create the file metadata
        const metadata = {
            contentType: 'image/jpeg'
        };

        let date = new Date();
        let fileName = '' + Math.floor(date.getTime() / 1000) + this.state.selectedFileName;
        fileName = fileName.replace(/\s+/g, '-').toLowerCase();
        this.setState({ selectedFileName: fileName })

        // Upload file and metadata to the object 'images/mountains.jpg'
        const uploadTask = storageRef.child(IMAGE_FOLDER_NAME + '/' + fileName).put(this.state.selectedFile, metadata);

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on('state_changed', // or 'state_changed'
            (snapshot) => {
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
                this.setState({ uploadProgress: progress });
                /* switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        console.log('Upload is paused');
                        break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        console.log('Upload is running');
                        break;
                } */
            }, (error) => {

                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                    case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;

                    case 'storage/canceled':
                        // User canceled the upload
                        break;

                    case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        break;
                    default: //something else happened
                }
                alert('Some error occured', String(error));
                this.setState({ loader: false })
            }, () => {
                // Upload completed successfully, now we can get the download URL
                uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                    this.setState({ uploadedFileUrl: String(downloadURL) },
                        () => {
                            this._publishPoster();
                        });
                    //alert('Upload finished ' + downloadURL);
                });
            });
    }

    deleteUploaded() {

        if (this.state.selectedFile && this.state.selectedFileName && this.state.uploadProgress === 100) {
            this.setState({
                loader: true
            }, () => {
                // Create a reference to the file to delete
                var desertRef = storageRef.child(IMAGE_FOLDER_NAME + '/' + this.state.selectedFileName);
                // Delete the file
                desertRef.delete().then(() => {
                    // File deleted successfully
                    alert('File deleted successfully!');
                    this.setState({
                        selectedFile: null,
                        selectedFileName: null,
                        uploadedFileUrl: null,
                        uploadProgress: 0,
                        loader: false,
                    })
                }).catch((error) => {
                    // Uh-oh, an error occurred!
                    alert('Some error occured deleting the file,\n' + String(error));
                    this.setState({ loader: false });
                });




            })
        }


    }

    _validate() {
        let errorFields = [];

        if (!this.state.posterTitle || this.state.posterTitle.trim().length === 0)
            errorFields.push('Poster Title can not be empty')

        if (this.state.posterExternalUrl.length > 0 && !this.state.posterExternalUrl.match(URLExpression))
            errorFields.push('Invalid Extermal URL format')

        if (!this.state.posterContentType)
            errorFields.push('Content Type field can not be empty')

        if (!this.state.posterCategoryId)
            errorFields.push('Category ID can not be empty')

        if (!this.state.selectedFile || !this.state.selectedFileName
            //|| this.state.uploadProgress !== 100
        )
            errorFields.push('Upload the poster file')

        if (!this.state.posterDescription || this.state.posterDescription.trim().length === 0)
            errorFields.push('Poster description or keyword is compulsory')

        return errorFields;
    }

    submit() {
        this.setState({ loader: true });

        if (this._validate().length !== 0) {
            alert("Error! \n" + this._validate().toString());
            this.setState({ loader: false })
        } else {
            if (window.confirm('Are you sure you want to Publish this poster ?')) {
                this._startUploadingFile()
            } else {
                this.setState({ loader: false })
            }
        }
    }

    _publishPoster() {

        const data = {
            id: 0,
            contentType: this.state.posterContentType,
            categoryId: Number(this.state.posterCategoryId),
            time: new Date().getTime(),
            title: this.state.posterTitle,
            description: this.state.posterDescription,
            imgUrl: String(this.state.uploadedFileUrl),
            infoUrl: String(this.state.posterExternalUrl)
        }

        console.log(data);

        db.collection(POSTER_COLLECTION_FOLDER_NAME).add(data)
            .then((docRef) => {
                console.log("Document written with ID: ", docRef.id);

                const posterRef = db.collection(POSTER_COLLECTION_FOLDER_NAME).doc(docRef.id);

                // upaded id field of data to firebase autogenerated id
                posterRef.update({
                    id: docRef.id,
                    time: firebase.firestore.FieldValue.serverTimestamp(),
                })
                    .then(() => {
                        console.log("Document successfully updated!");
                        this.setState({ loader: false }, () => {
                            alert('Published!');
                            this.setState({ goHome: true })
                        })

                    })
                    .catch((error) => {
                        // The document probably doesn't exist.
                        console.error("Error updating document: ", error);
                        this.setState({ loader: false })
                        alert('Error!');
                    });
            })
            .catch((error) => {
                console.error("Error adding document: ", error);
                this.setState({ loader: false })
                alert('Error publishing!');
            });
    }

    render() {
        if (this.state.goHome) {
            return <Redirect to='/' />;
        }
        return (
            <AuthContainer>

                <View style={{ alignItems: 'center', padding: 50 }}>
                    <Text style={styles.title}>Publish New Poster</Text><hr />
                    <View>
                        <TextInput placeholder="Poster Title..." style={styles.uploadInputbox} value={this.state.posterTitle} onChangeText={(val) => {
                            this.setState({ posterTitle: val })
                        }} />

                        <TextInput placeholder="External URL(optional)" style={styles.uploadInputbox} value={this.state.posterExternalUrl} onChangeText={(val) => {
                            this.setState({ posterExternalUrl: val })
                        }} />

                        <TextInput placeholder="Keywords or description" style={[styles.uploadInputbox, { height: 100 }]} value={this.state.posterDescription} onChangeText={(val) => { this.setState({ posterDescription: val }) }} multiline />

                        <View>
                            <Text style={styles.uploadLabel}>Upload Poster(2048x2048): </Text><br />
                            <Text style={styles.greyText}>{this.state.uploadedFileUrl ? (<a href={this.state.uploadedFileUrl} target='_blank' rel='noopener noreferrer'>{'preview'}</a>) : null}</Text>
                            <Text style={styles.greyText}>{this.state.uploadProgress !== 0 ? this.state.uploadProgress + '% uploaded' : null}</Text><br />
                            <View style={{ flexDirection: 'row', marginBottom: 10 }}>
                                <input type="file" onChange={this.handleselectedFile} />
                                {this.state.uploadProgress === 100 ? (<Button title="Delete" onPress={this.deleteUploaded} color="red" disabled />) : null}
                            </View>
                        </View>


                        <View>
                            <Text style={styles.uploadLabel}>Content Type: </Text>
                            <Picker
                                selectedValue={this.state.posterContentType}
                                style={styles.uploadPicker}
                                onValueChange={(itemValue, itemIndex) => {
                                    if (itemValue !== '0')
                                        this.setState({ posterContentType: itemValue })
                                }
                                }>
                                <Picker.Item label="Select..." value={'0'} />
                                <Picker.Item label="Picture Fact" value="picfact" />
                            </Picker>
                        </View>

                        <View>
                            <Text style={styles.uploadLabel}>Category ID: </Text>
                            <Picker
                                selectedValue={this.state.posterCategoryId}
                                style={styles.uploadPicker}
                                onValueChange={(itemValue, itemIndex) => {
                                    if (itemValue !== '0')
                                        this.setState({ posterCategoryId: Number(itemValue) })
                                }
                                }>
                                <Picker.Item label="Select..." value={'0'} />
                                {categories.map(category => {
                                    return (
                                        <Picker.Item label={category.name} value={category.id} key={category.id} />
                                    )
                                })}
                            </Picker>
                        </View>

                        <Button title="Publish" onPress={() => this.submit()} disabled={this.state.loader} />
                        {this.state.loader ? <ActivityIndicator size="large" color="#0000ff" /> : null}
                    </View>
                </View>
            </AuthContainer>

        )
    }
}

const styles = StyleSheet.create({
    uploadInputbox: {
        borderBottomColor: '#5a80f8',
        borderBottomWidth: 2,
        fontSize: 20,
        marginBottom: 10
    },
    uploadPicker: {
        height: 30,
        marginBottom: 10
    },
    uploadLabel: {
        fontSize: 15
    },
    title: {
        fontSize: 28
    },
    greyText: {
        color: '#a1a6a9',
        maxWidth: '100%'
    }
})